import { Home, Map, Users, Sparkles, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";

const PRESETS = {
  home: { icon: Home, headline: "Welcome to Stage Door", subtext: "Your private VIP tour dashboard — no one else can see your data. Start by uploading a tour-sheet screenshot or adding a tour." },
  tours: { icon: Map, headline: "No tours yet", subtext: "Upload a tour-sheet screenshot or add a tour by hand. Your guests, schedule and stats all grow from here." },
  guests: { icon: Users, headline: "Your guest list is empty", subtext: "Once you log a tour, its guests show up here with their preferences, hometown and celebration dates." },
  insights: { icon: Sparkles, headline: "Insights arrive with your tours", subtext: "Log a few tours and this page fills with your numbers — plus you can ask anything about them in plain English." },
  calendar: { icon: Calendar, headline: "Nothing on the calendar", subtext: "Your upcoming tours, shifts and guest celebrations will appear here as you add them." },
};

export function EmptyState({ variant = "tours", onAction, actionLabel, testid }) {
  const { resolved } = useTheme();
  const dark = resolved !== "light";
  const preset = PRESETS[variant] || PRESETS.tours;
  const Icon = preset.icon;
  return (
    <div className="flex flex-col items-center px-6 py-14 text-center" data-testid={testid || `empty-${variant}`}>
      <div
        className="relative mb-6 flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border border-[#9B2226]/40 shadow-lg shadow-black/30"
        style={{ backgroundImage: "url(/logo.jpg)", backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <span className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/70" />
        <Icon className="relative h-9 w-9 text-white drop-shadow" />
      </div>
      <h2 className={`font-display text-2xl font-800 tracking-tight ${dark ? "text-zinc-50" : "text-zinc-900"}`}>{preset.headline}</h2>
      <p className={`mt-2 max-w-sm text-sm ${dark ? "text-zinc-400" : "text-zinc-500"}`}>{preset.subtext}</p>
      {onAction && actionLabel && (
        <Button
          onClick={onAction}
          className="mt-6 rounded-full bg-[#9B2226] px-6 text-white transition-transform hover:bg-[#7A1A1E] active:scale-95"
          data-testid={`empty-${variant}-action`}
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
